import { render, staticRenderFns } from "./png.vue?vue&type=template&id=18615988&"
import script from "./png.vue?vue&type=script&lang=js&"
export * from "./png.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports